import { mmFetchWithResponse } from 'api/mmFetchWithResponse';

const VALUE_PROPS_BASE = 'api/catalog/v1';

const valuePropsApi = {
    getValueProps: async ({ signal } = {}) => mmFetchWithResponse(`${VALUE_PROPS_BASE}/value-props`, { signal }),

    getValuePropsForExternalSku: async (externalSku, { signal } = {}) =>
        mmFetchWithResponse(`${VALUE_PROPS_BASE}/external-skus/${externalSku}/value-props`, { signal }),

    addValuePropToExternalSku: async (externalSku, valuePropID) =>
        mmFetchWithResponse(`${VALUE_PROPS_BASE}/external-skus/${externalSku}/value-props`, {
            method: 'POST',
            body: JSON.stringify({ valuePropID }),
        }),

    removeValuePropFromExternalSku: async (externalSku, valuePropID) =>
        mmFetchWithResponse(`${VALUE_PROPS_BASE}/external-skus/${externalSku}/value-props/${valuePropID}`, {
            method: 'DELETE',
        }),
};

export { valuePropsApi };
